import React, { Component } from 'react';
import { message } from 'antd';
import MachineRepairsAddView from '../views/MachineRepairsAddView';
import { base } from '../../base';

class MachineRepairsAddContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            repair: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.repairId = this.props.repairId;
        this.repairRef = null;
    }

    componentDidMount() {
        if (this.repairId) {
            this.repairRef = base.syncState(`repairs/${this.props.extraUser.companyid}/${this.repairId}`, {
                context: this,
                state: 'repair',
            });
        }
    }

    componentWillUnmount() {
        if (this.repairRef != null) {
            base.removeBinding(this.repairRef);
        }
    }

    handleSubmit(values) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;
        const repairId = this.props.repairId;
        const { closeForm } = this.props;
        if (repairId) {
            this.handleUpdate(values);
        } else {
            base.push(`repairs/${this.props.extraUser.companyid}/`, {
                data: {
                    closeAt: (new Date()).getTime(),
                    cost: values.cost,
                    createdAt: (new Date()).getTime(),
                    createdBy: extraUser.key,
                    details: values.details,
                    machineid: machineId,
                    status: values.status,
                    part: values.part,
                },
                then(err) {
                    if (!err) {
                        message.success('Reparación Agregada exitosamente');
                        closeForm();
                    }
                },
            });
        }
    }

    handleUpdate(values) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;
        const repairId = this.props.repairId;
        const { closeForm } = this.props;
        base.update(`repairs/${this.props.extraUser.companyid}/${repairId}`, {
            data: {
                closeAt: (new Date()).getTime(),
                cost: values.cost,
                createdAt: (new Date()).getTime(),
                createdBy: extraUser.key,
                details: values.details,
                machineid: machineId,
                status: values.status,
                part: values.part,
            },
            then(err) {
                if (!err) {
                    message.success('Reparación Editada exitosamente');
                    closeForm();
                }
            },
        });
    }

    render() {
        return (
            <MachineRepairsAddView
                repair={this.state.repair}
                openForm={this.props.openForm}
                onCancel={this.props.onCancel}
                closeForm={this.props.closeForm}
                handleSubmit={this.handleSubmit}
            />
        );
    }
}

export default MachineRepairsAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineRepairsAddContainer.js